import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=51a83022&scoped=true&"
import script from "./HomeAdmin.vue?vue&type=script&lang=js&"
export * from "./HomeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HomeAdmin.vue?vue&type=style&index=0&id=51a83022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a83022",
  null
  
)

export default component.exports